import { computed, ref, Ref } from "@vue/composition-api";
import { uniq } from "lodash";
import { Group } from "@scrile/api-provider/dist/api/GroupsProvider";

type UserIdsMap = Record<string, boolean>;

export const useGroupSelection = (groups: Ref<Group[]>) => {
  const excludeGroupIdsLocal = ref<string[]>([]);
  const selectedGroupIdsLocal = ref<string[]>([]);
  const toggleSelection = (status: boolean, groupId: string, localState: Ref<string[]>) => {
    if (status) {
      localState.value.push(groupId);
    } else {
      localState.value = localState.value.filter(i => i !== groupId);
    }
  };
  const getUserIdsFromGroups = (comparedGroupIds: string[]): string[] => {
    const out: string[] = [];
    comparedGroupIds.forEach(groupId => {
      const foundGroup = groups.value.find(g => g.id === groupId);
      if (foundGroup) {
        out.push(...foundGroup.memberIds);
      }
    });
    return out;
  };
  const unmarkGroup = (id: string, localState: Ref<string[]>) => {
    localState.value = localState.value.filter(i => i !== id);
  };

  const excludedUserIdMap = computed<UserIdsMap>(() => {
    const groupUserIds = getUserIdsFromGroups(excludeGroupIdsLocal.value);
    return groupUserIds.reduce<UserIdsMap>((acc, id) => {
      acc[id] = true;
      return acc;
    }, {});
  });

  const uniqSelectedUsers = computed<string[]>(() => {
    const groupAndSelectedUserIds = getUserIdsFromGroups(selectedGroupIdsLocal.value);
    return uniq(groupAndSelectedUserIds);
  });

  const selectedUserIds = computed<string[]>(() => {
    return uniqSelectedUsers.value.filter(id => !excludedUserIdMap.value[id]);
  });

  const getRecipientsCount = (selectedGroupIds: string[] = [], excludeGroupIds: string[] = []) => {
    const selectedUserIds = uniq(getUserIdsFromGroups(selectedGroupIds));
    const excludedUserIds = uniq(getUserIdsFromGroups(excludeGroupIds));
    const excludedUserIdsMap = excludedUserIds.reduce<UserIdsMap>((acc, id) => {
      acc[id] = true;
      return acc;
    }, {});
    return selectedUserIds.filter(id => !excludedUserIdsMap[id]).length;
  };

  return {
    excludeGroupIdsLocal,
    selectedGroupIdsLocal,
    selectedUserIds,
    toggleSelection,
    unmarkGroup,
    getRecipientsCount,
  };
};
